export default "__VITE_ASSET__CytGu9Er__"